<script setup>
import {onMounted, ref} from "vue";

    const props = defineProps({
        portalId: {
            type: String,
            required: true
        },
        formId: {
            type: String,
            required: true
        }
    });

    const hubspotForm = ref(null);

    onMounted(() => {
        (() => {
            const script = document.createElement("script");
            script.setAttribute("type", "text/javascript");
            script.src = "https://js.hsforms.net/forms/embed/v2.js";

            script.addEventListener("load", () => {
                hbspt.forms.create({
                    portalId: "6681979",
                    formId: "06b58bb4-fb5b-406f-bfe0-4db84815d103",
                    region: "na1",
                    target: "#form-embed"
                });
            });

            hubspotForm.value.append(script);
        })();
    })
</script>

<template>
    <div id="form-embed" class="w-full">
        <div ref="hubspotForm" ></div>
    </div>
</template>
